import { Getter } from 'vuex-simple';
import { BaseModule } from '@/HostApp/store/ApsModules/BaseModule';
import { $bus } from '@/HostApp/services/Bus';

enum APP_COLLECTOR {
	APPLY = 'apps-collector-apply'
}

export enum MODAL_DIALOG {
	CLOSE_POPUP = 'close_popup'
}

export class AppModule extends BaseModule {
	constructor() {
		super();
		this.createProxyHandler(this, '_apply', this._apply);
		this.createProxyHandler(this, 'onNext', this.onNext);
		this.createProxyHandler(this, 'onPrev', this.onPrev);
		this.createProxyHandler(this, 'onSubmit', this.onSubmit);
		this.createProxyHandler(this, 'onCancel', this.onCancel);
		this.createProxyHandler(this, '_onContext', this._onContext);
		this.createProxyHandler(this, '_onHidePopup', this._onHidePopup);
	}

	/**
	 * Methods bellow described for typing and future implementation
	 **/

	public _onHideConfirm(value: boolean): void {
		//
	}

	public _onHidePopup = {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		apply: (target: Common.FnAny, thisArg: any, args: ArrayLike<any>): any => {
			$bus.$emit(MODAL_DIALOG.CLOSE_POPUP);
			return Reflect.apply(target, thisArg, args);
		}
	};

	@Getter()
	protected get currentView(): APS.IView {
		return window.aps.context._view;
	}

	public _onContext = {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		apply: (target: Common.FnAny, thisArg: any, args: ArrayLike<any>): any => {
			if (this.currentView.isVue) {
				$bus.$emit(APP_COLLECTOR.APPLY, { id: `vue_${this.currentView.id}`, method: '_onContext', args });
			} else {
				return Reflect.apply(target, thisArg, args);
			}
		}
	};

	public _apply = {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		apply: (target: Common.FnAny, thisArg: any, args: ArrayLike<any>): any => {
			const [viewId, functionName, params] = Array.from(args) as [string, string, APS.IApsContext | APS.IView];
			const aps = window.aps;
			let id;

			if (aps.wizard.active && functionName === 'onSubmit') {
				const { view } = aps.wizard;
				id = `${view.isVue ? 'vue_' : ''}${view.id}`;
			} else {
				const view = (
					(params as APS.IApsContext)._view ? (params as APS.IApsContext)._view : params
				) as APS.IView;
				id = viewId.includes('#') ? viewId : `${view.isVue ? 'vue_' : ''}${view.id}`;
			}

			if (id.startsWith('vue_')) {
				$bus.$emit(APP_COLLECTOR.APPLY, { id, method: functionName, args: params });
			} else {
				return Reflect.apply(target, thisArg, args);
			}
		}
	};

	public onCancel = {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		apply: (target: Common.FnAny, thisArg: any, args: ArrayLike<any>): any => {
			if (this.currentView.isVue) {
				$bus.$emit(APP_COLLECTOR.APPLY, { id: `vue_${this.currentView.id}`, method: 'onCancel', args });
			} else {
				return Reflect.apply(target, thisArg, args);
			}
		}
	};

	public onSubmit = {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		apply: (target: Common.FnAny, thisArg: any, args: ArrayLike<any>): any => {
			if (this.currentView.isVue) {
				$bus.$emit(APP_COLLECTOR.APPLY, { id: `vue_${this.currentView.id}`, method: 'onSubmit', args });
			} else {
				return Reflect.apply(target, thisArg, args);
			}
		}
	};

	public onNext = {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		apply: (target: Common.FnAny, thisArg: any, args: ArrayLike<any>): any => {
			if (this.currentView.isVue) {
				$bus.$emit(APP_COLLECTOR.APPLY, { id: `vue_${this.currentView.id}`, method: 'onNext', args });
			} else {
				return Reflect.apply(target, thisArg, args);
			}
		}
	};

	public onPrev = {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		apply: (target: Common.FnAny, thisArg: any, args: ArrayLike<any>): any => {
			if (this.currentView.isVue) {
				$bus.$emit(APP_COLLECTOR.APPLY, { id: `vue_${this.currentView.id}`, method: 'onPrev', args });
			} else {
				return Reflect.apply(target, thisArg, args);
			}
		}
	};
}

const appModule = new AppModule();

export default appModule;
